import { render, staticRenderFns } from "./ColourPicker.vue?vue&type=template&id=94e1cad4&"
import script from "./ColourPicker.vue?vue&type=script&lang=js&"
export * from "./ColourPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColourPicker.vue?vue&type=style&index=0&id=94e1cad4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QBtn,QPopupProxy,QColor});
